import('./bootstrap');

/**
 * Flag to let other MFE to know they are being executed inside this context
 */
/* @ts-ignore */
window.isRunningAsModule = true;
export {};
